import { render, staticRenderFns } from "./AccFood.vue?vue&type=template&id=5a45b1a4&"
import script from "./AccFood.vue?vue&type=script&lang=js&"
export * from "./AccFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports